<template>
  <v-dialog :value="value" :width="400" persistent scrollable>
    <v-card v-if="rendered">
      <v-card-title class="title">{{ title }}</v-card-title>
      <v-card-text>
        <slot :id="formId" />
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn :disabled="submitting" @click="$emit('input', false)">{{ $t('cancel') }}</v-btn>
        <v-btn type="submit" color="primary" :form="formId" :loading="submitting">{{
          $t('submit')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    submitting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rendered: this.value
    }
  },
  computed: {
    formId() {
      return `form-${this._uid}`
    }
  },
  watch: {
    value(val) {
      if (!val) {
        setTimeout(() => {
          this.rendered = val
        }, 300)
        return
      }
      this.rendered = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/LonBroadcast/Category/FormDialog.vue